import { UserInputTypes } from '@server/user-inputs';
import { ConfigurationTypeToDocumentationTabType } from '../../types/enums/DocumentationTabTypes';
import { DocumentationItemsMap } from './createDocumentationItemsMap';

export const findConfigurationType = (
  parserItems: DocumentationItemsMap,
  configurationId: string,
): keyof typeof ConfigurationTypeToDocumentationTabType | null => {
  let configurationType: keyof typeof ConfigurationTypeToDocumentationTabType | null = null;
  Object.entries(parserItems).forEach(([configType, configIds]) => {
    if (Array.isArray(configIds) && configIds.includes(configurationId)) {
      configurationType = configType as keyof typeof ConfigurationTypeToDocumentationTabType;
    }
  });
  return configurationType;
};

export const extractTagIdsFromUserInputs = (userInputs: any) => {
  const allTagIds: string[] = [
    ...userInputs[UserInputTypes.Tags],
    ...(userInputs[UserInputTypes.Owner] ? [userInputs[UserInputTypes.Owner]] : []),
    ...userInputs[UserInputTypes.Collaborators],
  ];
  return allTagIds.filter((tagId) => !!tagId); // Remove empty strings
};
